import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getQuota() {
    return axios.get(`${this.url}/quota`);
  }
}

export default new CampaignsAPI();
